import { defineMessages } from 'react-intl';

/** The copy of a suggestion that matches a song of the catalog (design catalog-merge c1-c3). */
export const claimWayMessages = defineMessages({
  matches: { id: 'app.sml.catalog.suggestions.match.sure', defaultMessage: 'Matches “{title}” in your catalog' },
  maybe: { id: 'app.sml.catalog.suggestions.match.possible', defaultMessage: 'Maybe “{title}” in your catalog' },
  sameSong: { id: 'app.sml.catalog.suggestions.match.sameSong', defaultMessage: 'Same song' },
  check: { id: 'app.sml.catalog.suggestions.match.check', defaultMessage: 'Check' },
  addsLink: {
    id: 'app.sml.catalog.suggestions.match.addsLink',
    defaultMessage: 'Merge adds the {service} link to it',
  },
  notTheSame: { id: 'app.sml.catalog.suggestions.match.notTheSame', defaultMessage: 'Not the same' },
  merge: { id: 'app.sml.catalog.suggestions.match.merge', defaultMessage: 'Merge' },
  mergeFailed: {
    id: 'app.sml.catalog.suggestions.match.mergeFailed',
    defaultMessage: 'We could not merge the release. Nothing changed. Try again.',
  },
  question: { id: 'app.sml.catalog.claim.way.question', defaultMessage: 'Is “{title}” a new song?' },
  wayNew: { id: 'app.sml.catalog.claim.way.new', defaultMessage: 'Add as a new release' },
  wayNewHelp: {
    id: 'app.sml.catalog.claim.way.newHelp',
    defaultMessage: 'A new row in your catalog, ready for a SmartLink.',
  },
  wayNewNextTo: { id: 'app.sml.catalog.claim.way.newNextTo', defaultMessage: 'A second row next to “{title}”.' },
  wayMerge: { id: 'app.sml.catalog.claim.way.merge', defaultMessage: 'Merge into an existing song' },
  wayMergeHelp: {
    id: 'app.sml.catalog.claim.way.mergeHelp',
    defaultMessage: 'The same song is in your catalog already. It gets the store links of this release.',
  },
  matchesHeading: { id: 'app.sml.catalog.claim.way.matches', defaultMessage: 'Matches' },
  pickAnother: { id: 'app.sml.catalog.claim.way.pickAnother', defaultMessage: 'Pick another song' },
  mergeInto: { id: 'app.sml.catalog.claim.way.mergeInto', defaultMessage: 'Merge into {title}' },
  pickFirst: { id: 'app.sml.catalog.claim.way.pickFirst', defaultMessage: 'Pick a song' },
  keepsNote: { id: 'app.sml.catalog.claim.way.keepsNote', defaultMessage: 'Nothing you made for {title} changes.' },
});
